export const DRIVEN_WHEELS_IDS = {
  AWD: '1',
  FRONT: '3',
  REAR: '4'
}

export const DRIVEN_WHEELS = {
  [DRIVEN_WHEELS_IDS.AWD]: {
    id: DRIVEN_WHEELS_IDS.AWD,
    name: 'SEARCH_BOX_SELECT_DRIVEN_WHEELS_ALL'
  },
  [DRIVEN_WHEELS_IDS.FRONT]: {
    id: DRIVEN_WHEELS_IDS.FRONT,
    name: 'SEARCH_BOX_SELECT_DRIVEN_WHEELS_FRONT'
  },
  [DRIVEN_WHEELS_IDS.REAR]: {
    id: DRIVEN_WHEELS_IDS.REAR,
    name: 'SEARCH_BOX_SELECT_DRIVEN_WHEELS_REAR'
  }
}
